/**
 * Downloading a report as CSV or Excel. Takes rows from exportRows() in
 * reportTable: one property per column, numbers as numbers.
 */

export function toCsv(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return '';
  const columns = Object.keys(rows[0]);
  const escape = (v) => {
    if (v === null || v === undefined) return '';
    const s = String(v);
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const lines = [columns.map(escape).join(',')];
  for (const row of rows) lines.push(columns.map((c) => escape(row[c])).join(','));
  return lines.join('\r\n');
}

function safeFilename(name, ext) {
  return `${String(name || 'report').replace(/[^a-z0-9-_ ]/gi, '').trim().replace(/\s+/g, '_') || 'report'}.${ext}`;
}

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function downloadCsv(rows, name) {
  const csv = toCsv(rows);
  const bom = String.fromCharCode(0xfeff); // Excel-friendly UTF-8 marker
  triggerDownload(new Blob([bom + csv], { type: 'text/csv;charset=utf-8' }), safeFilename(name, 'csv'));
}

export async function downloadXlsx(rows, name) {
  const XLSX = await import('xlsx');
  const sheet = XLSX.utils.json_to_sheet(rows);
  const book = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(book, sheet, 'Report');
  const out = XLSX.write(book, { bookType: 'xlsx', type: 'array' });
  triggerDownload(new Blob([out], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), safeFilename(name, 'xlsx'));
}
